

































































import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'
import { MAX_CHECKS_ALLOWED } from '@/config/constants'
import User from '../components/User/User.vue'
import Language from '../components/Language/Language.vue'

export default Vue.extend({
  components: {
    User,
    Language
  },
  data: () => ({
    drawer: null,
    items: [
      { label: 'Checks', icon: 'icon-pneuma-search-outline', to: '/check' },
      { label: 'History', icon: 'icon-pneuma-history-outline', to: '/history' }
    ],
    selectedItem: 1,
    dialog: false
  }),
  computed: {
    ...mapGetters(['isModalOpen']),
    ...mapGetters('results', ['getChecksCounter']),
    fillStyle () {
      const percentage = Math.round(this.getChecksCounter / MAX_CHECKS_ALLOWED * 100)

      if (percentage === 100) {
        return {
          width: `${percentage}%`,
          borderRadius: '1.5rem'
        }
      }

      return {
        width: `${percentage}%`
      }
    }
  },
  methods: {
    ...mapActions('results', ['updateChecksCounter']),
    handleRedirection () {
      window.location.assign('https://checks.truora.com/')
    }
  },
  mounted () {
    this.updateChecksCounter()
  }
})
